import { render, staticRenderFns } from "./OffMarketAccess.vue?vue&type=template&id=4b65d421&scoped=true&"
import script from "./OffMarketAccess.vue?vue&type=script&lang=ts&"
export * from "./OffMarketAccess.vue?vue&type=script&lang=ts&"
import style0 from "./OffMarketAccess.vue?vue&type=style&index=0&id=4b65d421&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b65d421",
  null
  
)

export default component.exports